import { SET_ACCOUNT } from './types';

const initialState = {};

export const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACCOUNT:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const account = state => state.account;
const accountId = state => state.account.id;
const accountType = state => {
  const accountTypeByPortalType = {
    1: 'DEALER',
    2: 'LENDER',
    3: 'PARTNER',
  };

  return accountTypeByPortalType[state.account?.portalType];
};

const accountSelectors = {
  account,
  accountId,
  accountType,
};

export { accountSelectors };
